import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';

const RenameDialog = ({ open, currentName, isUpdating, onSave, onClose }) => {
  const [stem, setStem] = React.useState('');
  const [extension, setExtension] = React.useState('');

  React.useEffect(() => {
    if (open) {
      const fullName = currentName || '';
      const lastDot = fullName.lastIndexOf('.');
      if (lastDot > 0) {
        setStem(fullName.substring(0, lastDot));
        setExtension(fullName.substring(lastDot));
      } else {
        setStem(fullName);
        setExtension('');
      }
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <FormattedMessage id="hostFiles.rename" defaultMessage="Rename" />
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          value={stem}
          onChange={(e) => setStem(e.target.value)}
          margin="dense"
          InputProps={
            extension
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography variant="body2" color="textSecondary">
                        {extension}
                      </Typography>
                    </InputAdornment>
                  ),
                }
              : undefined
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isUpdating}>
          <FormattedMessage id="Cancel" defaultMessage="Cancel" />
        </Button>
        <Button
          onClick={() => onSave(stem.trim() + extension)}
          color="primary"
          disabled={isUpdating || !stem.trim()}
        >
          <FormattedMessage id="Save" defaultMessage="Save" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RenameDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  currentName: PropTypes.string,
  isUpdating: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RenameDialog;
